module.exports = __webpack_public_path__ + "static/media/game-display-1.b974675a.png";